import { render, staticRenderFns } from "./LinhaDeContasAReceberDetalhes.vue?vue&type=template&id=508cd3f3&scoped=true"
import script from "./LinhaDeContasAReceberDetalhes.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeContasAReceberDetalhes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeContasAReceberDetalhes.vue?vue&type=style&index=0&id=508cd3f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508cd3f3",
  null
  
)

export default component.exports